import clsx from "clsx";
import { FC, useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa6";

type FAQProps = {
  question: string;
  answer: string;
  opened?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
};
export const FAQ: FC<FAQProps> = ({
  question,
  answer,
  opened = false,
  onOpen = () => null,
}) => {
  const [isOpened, setOpened] = useState<boolean>(opened);

  useEffect(() => {
    setOpened(opened);
  }, [opened]);

  const handleClick = () => {
    !isOpened && onOpen();

    setOpened(!isOpened);
  };

  return (
    <div className="faq">
      <button
        type="button"
        className={clsx("faq-btn", { opened: isOpened })}
        onClick={handleClick}
      >
        {question}
        <span>
          <FaChevronDown size={12} />
        </span>
      </button>

      <div className={clsx("answer", { opened: isOpened })}>
        <div className="overflow-hidden">{answer}</div>
      </div>
    </div>
  );
};
